






import {
  defineComponent,
} from '@vue/composition-api';

import PageColumnWithVisitorList from '@/components/Live/PageColumnWithVisitorList.vue';

const List = defineComponent({
  components: {
    PageColumnWithVisitorList,
  },
  // setup() {
  //   return {};
  // },
});

export default List;
